import {
  GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS,
  GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_SUCCESS, 
  GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS, 
  GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_ERROR, 
  GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_SUCCESS, 
  UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS, 
  UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_ERROR, 
  UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_SUCCESS, 
  UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS, 
  UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_ERROR, 
  UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_SUCCESS
} from "./actionTypes"

// FOR GET CALLS DASHBOARD CAMPAIGNS STICKY COLUMNS
export const getCallsDashboardStatesStickyColumns = () => {
  return {
    type: GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS,
  }
}

export const getCallsDashboardStatesStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getCallsDashboardStatesStickyColumnsError = error => {
  return {
    type: GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// FOR UPDATE CALLS DASHBOARD STATES STICKY COLUMNS
export const updateCallsDashboardStatesStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateCallsDashboardStatesStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateCallsDashboardStatesStickyColumnsError = error => {
  return {
    type: UPDATE_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// FOR GET CALLS DASHBOARD CAMPAIGNS STICKY COLUMNS
export const getCallsDashboardCampaignsStickyColumns = () => {
  return {
    type: GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS,
  }
}

export const getCallsDashboardCampaignsStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getCallsDashboardCampaignsStickyColumnsError = error => {
  return {
    type: GET_CALLS_DASHBOARD_STATES_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// FOR UPDATE CALLS DASHBOARD CAMPAIGNS STICKY COLUMNS
export const updateCallsDashboardCampaignsStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateCallsDashboardCampaignsStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateCallsDashboardCampaignsStickyColumnsError = error => {
  return {
    type: UPDATE_CALLS_DASHBOARD_CAMPAIGNS_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}


